/**
 * The backend refuses a second copy of a booking with "Item already exists".
 *
 * That rejection arrives in two shapes: `addToCartAndFetch` rejects with the
 * response's `title` as a bare string, while a direct axios call carries the
 * whole error object. Both are recognised here.
 */
const DUPLICATE_MESSAGE = "item already exists";

export const isDuplicateCartItemError = (error: unknown): boolean => {
    if (typeof error === "string") {
        return error.toLowerCase().includes(DUPLICATE_MESSAGE);
    }
    const candidate = error as
        | { message?: string; title?: string; response?: { data?: { title?: string } } }
        | null
        | undefined;
    const text = [
        candidate?.response?.data?.title,
        candidate?.title,
        candidate?.message,
    ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
    return text.includes(DUPLICATE_MESSAGE);
};
